module.exports = __webpack_public_path__ + "static/media/slide-email.1c9a4bc4.svg";